import CONF from '../Config.js'
import axios from 'axios'
import router from '../router/index'

export default {
  goLogin: function() {
    router.push('/')
  },
  test: function (id, password) {
    console.log('## test api ' + id + password)
    var aa = axios.get(CONF.TEST, {
      params: {
        serial: 1234
      }
    })
    console.log('##!' + aa)
  },
  login: function (id, password) {
    console.log('## login api ' + id + password)
    var result = axios.post(CONF.LOGIN, {
      id: id,
      password: password
    })
    return result
  },
  dashboard: function () {
    //console.log('## login api ' + id + password)
    var result = axios.get(CONF.DASHBOARD)
    return result
  },

  write: function (no, category, title, contents , writeDate) {
    console.log('## login api ' + category + title + ' ' + contents)
    var result = axios.post(CONF.WRITE, {
        no:no,
        category: category,
        title: title,
        contents:contents,
        writeDate:writeDate
      }
    )
    return result
  },
  delete: function (no) {
    console.log('## delete api ' + no)
    var result = axios.delete(CONF.DELETE, {params:{ no: no }
    })
    return result
  },

  reqContents: function (no) {
    console.log('## req contents api ' + no)
    var result = axios.get(CONF.REQ_CONTENTS, {params:{ no: no }
    })
    return result
  },
  reqList: function (type, category,page_no) {
    return axios.get(CONF.REQ_LIST, {
      params: {
        type: type,
        category: category,
        page_no: page_no
      }
    })
  },
  setAcessToken: function (token) {
    console.log('## setAcessToken ->' + token)
    axios.defaults.headers.common['Access-Token'] = token
  },
  fetchDevices: function () {
    console.log('## fetchDevices')
    return axios.get(CONF.FETCH_DEVICES)
  },
  findPassword: function (username, email) {
    return axios.post(CONF.LOGIN, {
      params: {
        usename: username,
        email: email
      }
    })
  },
  fetchContacts: function (pageno, pagesize) {
    return axios.get(CONF.FETCH, {
      params: {
        pageno: pageno,
        pagesize: pagesize
      }
    })
  },
  fetchDeviceOne: function (no) {
    return axios.get(CONF.FETCH_DEVICE_ONE.replace('${no}', no))
  },
  addDevice: function (device) {
    return axios.post(CONF.ADD, device)
  },
  deleteDevice: function (deviceNo) {
    //return axios.post(CONF.ADD, contact)
    return axios.delete(CONF.DELETE_DEVICE.replace('${no}', deviceNo))
  },
  updateDevice: function (devicesetting) {

    console.log('### ' + JSON.stringify(devicesetting))

    return axios.put(CONF.UPDATE_DEVICE.replace('${no}', devicesetting.no), devicesetting)
  },
  fetchUserInfo: function () {
    return axios.get(CONF.FETCH_USER_INFO) // .replace("${no}",no));
  },
  updateUserInfo: function (password, newpassword, userinfo) {
    var data = {password: password, newpassword: newpassword, userinfo: userinfo}
    console.log('## update userinfo : ' + data + ' ' + password + ' ' + newpassword)
    return axios.put(CONF.UPDATE_USER_INFO, data)
  },
  fetchMenuRanking: function (period, devicelist, order) {

    var params = {
      search_param: period,
      is_desc: order,
      device_no: devicelist
    }
    return axios.get(CONF.FETCH_MENU_RANKING,{ params: params })
  },
  deleteContact: function (no) {
    return axios.delete(CONF.DELETE.replace(`${no}`, no))
  },
  updatePhoto: function (date , deviceno , menuindex , file) {
    console.log('## updatePhoto2')
    var data = new FormData()
    console.log('## updatePhoto33')

    var paramObj = {deviceno:deviceno, date:date , menuindex :menuindex}
    console.log('## updatePhoto2222')
    var paramText = JSON.stringify(paramObj)
    console.log('## updatePhoto44 : 333333')
    data.append('param', paramText )
    data.append('file', file)
    console.log('## updatePhoto44')
    return axios.post(CONF.UPLOAD_PHOTO, data)
  },
  deletePhoto: function (date , deviceno , menuindex) {
    console.log('## updatePhoto')
    //var data = new FormData()
    //data.append('param', {deviceno:deviceno, date:date , menuindex :menuindex} )
    console.log('## ' +deviceno + ' ' + date + ' ' + menuindex )
    var params = {
      deviceno:deviceno, date:date , menuindex :menuindex
    }

    console.log('## ' + JSON.stringify(params))

    return axios.delete(CONF.DELETE_PHOTO, { data : params } )
  },
  debugOut: function (obj) {
    var str = JSON.stringify(obj)
    console.log(str)
  },
  fetchMenuList: function(deviceno , startdate, enddate) {
    console.log('33 ' + deviceno)

    var params = {
      start_date: startdate,
      end_date: enddate
    }

    var no = 12
    // return axios.get(CONF.FETCH_DEVICES)
    //var cmd = CONF.FETCH_MENU_LIST.replace(`${no}`, 'dddd') // .replace(`${no}`, deviceno)
    var cmd  = CONF.DELETE.replace(`${no}`, parseInt(no))
    console.log('44 :: ' + cmd)
    console.log('44 ' + startdate)

    var str = "Visit Microsoft! ${no}";
    var res = str.replace('${no}', no);
    console.log('## str : ' + res)

    var v = axios.get(CONF.FETCH_MENU_LIST.replace('${no}', deviceno), { params: params } )
    console.log('##1 : ' + v)
    console.log('?? ')

    return v
  },
  fetchAllMenu: function(date) {
    var params = {
      date: date
    }
    return axios.get(CONF.FETCH_ALL_MENU, { params: params } )
  },
  updateMenu: function ( deviceno , menus ) {
    return axios.put(CONF.UPDATE_MENU.replace('${no}', deviceno), menus )

  },
  fetchDashboardPage: function ( period ) {
    // var p = '' + year + '-' + mon
    var params = { search_param: period }
    return axios.get(CONF.FETCH_DASHBOARD_PAGE , { params } )
  },
  fetchTotalDetailPreview: function (deviceno , enddate)
  {
    var params = {
      device_no: deviceno,
      end_date: enddate
    }
    console.log('!! dd')
    return axios.get(CONF.FETCH_TOTALDETAIL_PREVIEW , { params } )
  },
  fetchTotalDetail: function (deviceno , period , pageno)
  {
    var params = {
      search_param: period,
      device_no: deviceno,
      page_no: pageno
    }
    console.log('!! dd')
    return axios.get(CONF.FETCH_TOTALDETAIL , { params } )
  }

}



// WEBPACK FOOTER //
// ./src/api/api.js